export default "__VITE_ASSET__C7VIiu4U__"